import Cookies from 'js-cookie'
import { showWelcomeBanner } from '../../components/AlertBanner/index.js'
import { getUrlParameter } from '../data/url.js'
import {
  getAuthManagerInstance,
  setUsername,
  setProfileCookie,
  addUserContext,
  setEncryptedUserId,
  USER_LEVEL_TRACKING_ID_COOKIE_NAME,
  setTrackingIdCookie,
  ENCRYPTED_USER_ID_COOKIE_NAME,
} from './authentication-manager.js'
import { getLongTermCookieOptions } from '../environments/config.js'

export function init() {
  getAuthManagerInstance()
    .getProfileServiceBehaviorSubject()
    .subscribe((profile) => {
      if (profile) {
        setProfileCookie()
        setUsername(profile.emailId)

        if (getUrlParameter('registerSuccess')) {
          const params = {
            mode: profile.contactStatusCd === 'LEAD' ? 'LEAD' : 'CONTACT',
            profileData: profile,
          }
          showWelcomeBanner(params)
        }

        // const firstTimeContactLogin = window.localStorage.getItem('firstTimeContactLogin')
        // if (firstTimeContactLogin !== 'yes' && data.firstLogin && !App.isInternal()) {
        //   window.localStorage.setItem('firstTimeContactLogin', 'yes')

        const termsAgreementPageRedirected = window.sessionStorage.getItem(
          'termsAgreementPageRedirected'
        )
        if (
          termsAgreementPageRedirected !== 'yes' &&
          profile.tcStatus === 'No'
        ) {
          window.sessionStorage.setItem('termsAgreementPageRedirected', 'yes')
          window.location.href = '/login/terms-conditions'
        }

        if (
          Cookies.get('AuthManagerContactFirmChange') !== 'yes' &&
          profile.contactStatusCd === 'CONTACT_NEW_FIRM'
        ) {
          window.location.href = '/login/email-change'
          Cookies.set('AuthManagerContactFirmChange', 'yes', { secure: true })
        }

        setUserContextFromProfileData(profile)

        setEncryptedUserId(profile.emailId)
      }
    })

  // if (AmeripriseAdvisorAutoLogin.isAmeripriseAdvisor()) {
  //   AuthenticationManager.addUserContext("amp_advisor_yes");
  // }

  // ContentLoader.previewContent(AuthenticationManager.userContext);

  // if (isLoggedIn()) {
  //   AuthenticationManager.updateAuthenticated();
  // }

  // track this cookie with eVar15 in DTM
  if (!Cookies.get(USER_LEVEL_TRACKING_ID_COOKIE_NAME)) {
    setTrackingIdCookie()
  }

  //set CTN_UID if BUID query string exists
  setEncriptedUserIdBUID()
}

function setUserContextFromProfileData(profile) {
  if (profile.learningCenter) {
    addUserContext('lc_yes')
  }
}

function setEncriptedUserIdBUID() {
  if (window.location.search) {
    const urlParams = new URLSearchParams(window.location.search)
    const buID = urlParams.get('BU_ID')

    if (buID) {
      Cookies.set(ENCRYPTED_USER_ID_COOKIE_NAME, buID, {
        ...getLongTermCookieOptions(),
        secure: true,
      })
      return
    }
  }
}
